/**
 * DataTable のソート処理をおこなう
 */
$(function(){
    $(document).on('click', '.sorting', function(e){
        location.href = $(this).data('asc');
    });
    $(document).on('click', '.sorting_asc', function(e){
        location.href = $(this).data('desc');
    });
    $(document).on('click', '.sorting_desc', function(e){
        location.href = $(this).data('asc');
    });
});